<template>
  <div class="cblog-col" v-if="showLayout">
    <city-search :found="citySearched"/>
    <!--   <h2>Live Now</h2>
     <div class="cblog-cities live-now" v-if="all_data">

        <ul class="live-city-list">
          <li class="live-city-list-item"
              v-for="(data_item, index) in brooklynItems" :key="index"
              @click="subClick(data_item.city.name, data_item.area.name, data_item.area.id)"
          >
            <a class="live-city-list-item-link">{{data_item.area.name}}, {{ data_item.city.name }}</a>
          </li>
        </ul>
      </div>-->
    <h2>Turkish Restaurants Near Me</h2>
    <div class="cblog-cities coming-soon" v-if="all_data">

      <ul class="live-city-list">
        <li class="live-city-list-item"
            v-for="(data_item, index) in all_data" :key="index"
            @click="subClick(cityText, data_item.name, data_item.id)"
        >
          <a class="live-city-list-item-link">{{data_item.name}}, {{ cityText }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import CitySearch from './CitySearch'
export default {
  props: {
    area_id: {
      type: String,
      default: '0'
    },
    cityText: {
      type: String,
      default: '0'
    }
  },
  name: 'LiveCitiesList',
  components: {
    CitySearch
  },
  data () {
    return {
      areas: {},
      cities: null,
      all_data: null,
      showLayout: false
    }
  },
  watch: {
    areas: {
      deep: true,
      handler () {}
    }
  },
  computed: {
    all_list_items () {
      const result = []
      this.all_data.map(city => {
        city.sub_areas.map(area => {
          result.push({
            city,
            area
          })
        })
      })
      return result
    },
    brooklynItems () {
      return this.all_list_items.filter(data_item => data_item.area.name === 'Brooklyn')
    }
  },
  mounted () {
    //this.getAreaList(0)
    this.getAreaListAll(this.area_id)
  },
  methods: {
    citySearched (data_item) {
      this.subClick(data_item.city.name, data_item.area.name, data_item.area.id)
    },
    getAreaList (parent) {
      this.$vs.loading()
      const payload = {
        parent
      }
      this.$store.dispatch('api/getAreaList', payload)
        .then((response) => {
          this.$vs.loading.close()
          if (parent === 0) {
            this.cities = response.data.data
            this.areas = {}
            Object.keys(this.cities).map(city_id => {
              this.getAreaList(city_id)
            })
          } else {
            const areas = {
              city_id: parent,
              values: response.data.data
            }
            this.areas[parent] = areas

            if (Object.keys(this.areas).length === Object.keys(this.cities).length) {
              if (this.area_id !== '0') {
                let city_id = ''
                Object.keys(this.areas).map(area_var => {
                  const arr = Object.keys(this.areas[area_var].values).includes(this.area_id)
                  if (arr) {
                    city_id = this.areas[area_var].city_id
                  }
                })
                const city = this.cities[city_id]
                const area = this.areas[city_id].values[this.area_id]
                this.subClick(city, area, this.area_id)
              }
              this.showLayout = true
            }
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getAreaListAll (parent) {
      this.$vs.loading()
      const payload = {
        parent
      }
      this.$store.dispatch('api/getAreaListAll', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.all_data = response.data.data
          this.showLayout = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    subClick (city, url, id) {
      this.$vs.loading()
      this.setSelectedCity(url)
      this.$router.push({
        name: 'live-cities-area',
        params: {
          area: url.toLowerCase().replace(' ', '-'),
          city: city.toLowerCase().replace(' ', '-'),
          area_id: id.toString()
        },
        query: {

        }
      })
      this.$vs.loading.close()
    },
    setSelectedCity (text) {
      this.$store.dispatch('api/setSelectedCity', text)
    }
  }
}
</script>

<style lang="scss">
.live-city-list{
  width:100%;
}
.cblog-cities{

  &.live-now{
    .live-city-list{
      width:100%;
    }
  .live-city-list-item{
    flex-basis:100%;
    padding: 10px 10px 10px 0;
}
}
}
.live-city-list{
  display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.live-city-list-item{
  flex-basis: 25%;
    max-width: 25%;
    flex: 1 1 50%;
    padding: 10px 10px 10px 0;
}
.live-city-list-item-link{
  color: #666;
    display: block;
    cursor:pointer;
    &:hover, &:active{
      outline-width: 0;
      color:#666
    }
    &:hover{
      text-decoration: underline;
    }
}
@media (max-width:768px){
  .live-city-list-item{
    flex-basis: 100%;
    max-width: 100%;
  }
  .cblog-cities {
    padding: 0;
  }
}
</style>
